import Utils from "./utils";
import $ from 'jquery';
import 'slick-carousel';

class SliderAgencies {

	/**
	 * @param options
	 */
	constructor() {

		Utils.debug('SLIDER AGENCIES :: construct');

		this.$widgets = $('.barba-container:last-child .slider.agencies');

		//console.log(this.$widgets.length);
		if(this.$widgets.length === 0){
			return;
		}

		this.$widgets.each((index, elt) => {
			this.init($(elt));
		})
	}




	init($elt) {
		//console.debug('SLIDER AGENCIES :: init');

		let $slick = $elt.find('.slick');

		$slick.slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					}
				},
			]
		});

		$elt.find('.slider__control__btnLeft').on('click', () => {
			$slick.slick('slickPrev');
		});
		$elt.find('.slider__control__btnRight').on('click', () => {
			$slick.slick('slickNext');
		});

	}


}

module.exports = SliderAgencies;
